// extracted by mini-css-extract-plugin
export default {"pagination":"SuperPagination_pagination__Kx2Pj","text1":"SuperPagination_text1__KfgBm","text2":"SuperPagination_text2__3LVXD","select":"SuperPagination_select__ZNOn0"};